export enum ScreenSize {
    BP = 400,
    XS = 575,
    SM = 576,
    MD = 768,
    LG = 992,
    XL = 1200,
    HBP1 = 860,
}